moment.lang('zh_tw');

window.InifECShared.filter("timeAgo", function () {
  return function (date) {
  	var aDay = 86400000,
  		now = Date.now();

  	if (now - date >= aDay) {
			return moment(date).format('LL');
  	}
  	else {
    	return moment(date).fromNow();
      // return moment(date).format('LTS');
  	}
  };
});

window.InifECShared.filter("timeString", function () {
	return function (date) {
		if (date)
			return moment(date).format('LL');
		return "";
	}
});

window.InifECShared.filter("simpleTimeString", function () {
  return function (date) {
    if (date)
      return moment(date).format('YYYY/MM/DD');
    return "";
  }
});

window.InifECShared.filter("simpleDateTimeString", function () {
  return function (date) {
    if (date)
      return moment(date).format('YYYY/MM/DD') + moment(date).format(' HH:mm');
    return "";
  }
});

window.InifECShared.filter("dashedDateString", function () {
  return function (date) {
    if (date)
      return moment(date).format('YYYY-MM-DD');
    return "";
  }
});

window.InifECShared.filter("dashedDateTimeString", function () {
  return function (date) {
    if (date)
      return moment(date).format('YYYY-MM-DD') + moment(date).format(' HH:mm');
    return "";
  }
});

window.InifECShared.filter("minTimeString", function () {
  return function (date) {
    if (date)
      return moment(date).format('M/D');
    return "";
  }
});


window.InifECShared.filter("fullTime", function () {
  return function (date) {
    if (date)
      return moment(date).format('LL') + moment(date).format(' dddd a h:mm');
    return "";
  }
});

window.InifECShared.filter("timeWithWrap", function () {
  return function (date) {
    if (date)
      return moment(date).format('M/D') + '\n' + moment(date).format('HH:mm');
    return "";
  }
});

window.InifECShared.filter("formatNumber", function () {
  return function (date, decimal) {
    if (date){
      if(window.isNaN(date)){
        return 0;
      }

      return formatNumber(date, decimal);
    }

    return 0; // TOOD 沒有任何的data到底是要傳0好還是空字串好？
  }
});


window.InifECShared.filter("deliveryDateTimeString", function () {
    return function (date) {
        if (date)
          if(!window.isNaN(date)){
            if (date >= 86400000) {
              return date / 86400000;
            } else {
              return date;
            }
          }
            
        return "";
    }
});

window.InifECShared.filter("payExpireDateTimeString", function () {
    return function (date) {
        if (date && date.length == 8) {
          var yyyy = date.substring(0,4),
              mm = date.substring(4,6),
              dd = date.substring(6,8);

          return yyyy + "/" + mm + "/" + dd;
        }
            
        return "";
    }
});

// 計算預計時間
window.InifECShared.filter("estimatedDateTimeString", function() {
  return function (date) {
    if (date) {
      if(!window.isNaN(date)){

        var now = Date.now();
        var estimated = new Date(date + now);

        var dd = estimated.getDate();
        var mm = estimated.getMonth() + 1;
        var yyyy = estimated.getFullYear();

        mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
        dd = (dd < 10) ? '0' + dd.toString() : dd.toString();

        return yyyy + "年" + mm + "月" + dd + "日";
      }
    }
        
    return "";
  }
})

window.InifECShared.filter('mobilePhoneDash', function($sce) {
  return function(text) {
    if(text) {
      return text.substr(0, 4) + '-' + text.substr(4,3) + '-' + text.substr(7);
    } else {
      return text;
    }
  }
});

window.InifECShared.filter('startFrom', function() {
    return function(input, start) {
        if(input) {
            start = +start; //parse to int
            return input.slice(start);
        }
        return [];
    }
});

window.InifECShared.filter('hexToName', function() {
    return function(text) {
        if(text) {
            return window.classifier.classify(text);
        }
        return '';
    }
});

window.InifECShared.filter('formatCmsTimeString', function() {
  return function (str) {
    if (str) {
      var date = new Date(str)
      return moment(date).format('YYYY/MM/DD');
    }
    return "";
  }
})


window.InifECShared.filter('atmPaymentNumberDash', function($sce) {
  return function(text) {
    if(text) {
      var newtext = '';
      for(var i = 0; i < text.length; i++) {
        newtext = newtext.concat(text[i]);

        if(i%4 == 3 && i != text.length -1) {
          newtext = newtext.concat('-');
        }
      }

      return newtext;
    } else {
      return "";
    }
  }
});